export default __webpack_public_path__ + "e0906b4827c2333a6725c3af934f99d3.png";